import React, { Component } from 'react';
import { Provider } from './context/InfoContext'
import { withRouter } from 'react-router';
import { connect } from "react-redux";
import styled from 'styled-components';
import withTourCheck from './HOC/withTourCheck';
import Joyride from 'react-joyride';
import Creator from './Info/Creator';
import Rank from './Info/Rank'
import Recent from './Info/Recent'
import PastDay from './Info/PastDay'
import PastMonth from './Info/PastMonth'
import MainNav from './Info/MainNav';
import Graph from './Info/Graph';
import Tooltip from './Tour/Tooltip'
import TourToGuide from './Tour/TourToGuide'
import {fakeInfoData} from './Info/dev/fakeInfoData';
import {TourInfoData} from './Info/dev/TourInfoData'
import PageNotFound from './404';
import LoadingSpinner from './dev/LoadingSpinner'
import PaymentBanner from './Payment/PaymentBanner'
const { REACT_APP_URI = "/" } = process.env;

class Info extends Component {
    state = {
        info: "",
        infoId: -1,
        isLoading: true,
    }
    componentDidMount() {
        this.getInfo()
        this.getRecentChannels()
    }
    //導覽功能 function //
    handleJoyrideCallback = (data) => {
        const {tourToggleInfoProposal} = this
        const { action, index, step: {target} } = data;
        const finishedStatuses = ["close", "reset"]
        const StartStatus = ["start"]
        const element = document.querySelector(target);
        //spotlight置中
        if(element) {
            element.scrollIntoView({
                block: 'center' 
            });
            let spotlight = document.querySelector(".react-joyride__spotlight")
            if(spotlight && spotlight.style.position !== 'fixed'){
                const realPosition = `${spotlight.offsetTop + window.scrollY}px`
                spotlight.style.top = realPosition
            }
        }
        //結束教學
        if(finishedStatuses.includes(action)) {
            this.props.dispatch({ type: `setInfoTour`, [`isInfoTourActive`]: false })
        }
    }
    tourToggleInfoProposal = (value) => {
        this.setState({tourForceInfoListActive : value })
    }
    // tourToPayment = () => {
    //     const { user: {auth}} = this.props
    //     this.props.dispatch({ type: `setInfoListTour`, [`isInfoListTourActive`]: false })
    //     if(auth === "notSignIn") {
    //         this.props.dispatch({ type: 'toggleUserField', condition: 'signIn'})
    //     }
    //     else {
    //         this.props.dispatch({ 
    //             type: 'togglePaymentField', 
    //             isPaymentGuideActive: true,
    //             paymentGuideMinPlan: "Agency",
    //         })
    //     }
    // }
    ////導覽功能 function end//
    getRecentChannels = () => {
        fetch(`${REACT_APP_URI}/RecentChannels/`, { credentials: "include" })
        .then(res => {
            if(res.ok) return res.json()
            else throw res;
        })
        .then(res => this.props.dispatch({ 
            type: 'setRecentChannels', 
            recentChannels: res.recentChannels,
        }))
    }
    getInfo = () => {
        const { infoId } = this.props.match.params
        const { REACT_APP_URI = '/' } = process.env
        this.setState({ isLoading: true})
        fetch(`${REACT_APP_URI}/Info/${infoId}`,{credentials: "include"})
        .then(res => {
            if(res.status === 404) throw this.setState({ isLoading: false}) // ID不存在
            else return res.json()
        })
        .then(Info => this.setState({ info: Info, infoId: Info.pk, isLoading: false}))
    }
    render() {
        const { user:{plan, auth}, tour:{ isInfoTourActive }, messages } = this.props
        const {info, infoId, isLoading} = this.state
        const {handleJoyrideCallback} = this
        if(!isLoading && info === "") return <PageNotFound/>
        return (
            <Provider 
                value={ 
                    isInfoTourActive 
                        ? { ...TourInfoData, isBlur: false}
                        : (auth === 'notSignIn' || plan === 'Free' || plan === 'Creator') 
                            ? {...fakeInfoData, isBlur: true, ...info} 
                            : {...info, isBlur: false}}>
                <Joyride
                    callback={handleJoyrideCallback}
                    // getHelpers={() => StoreHelpers}
                    continuous={true}
                    run={isInfoTourActive}
                    scrollToFirstStep={true}
                    showProgress={true}
                    showSkipButton={true}
                    steps={[
                        { 
                            target: 'body',
                            placement: 'center',
                            title: messages.user_tour_info_1,
                            content: messages.user_tour_info_1_content,
                            hideCloseButton: true,
                            disableBeacon: true,
                        },
                        {
                            target: '#user_tour_info_2',
                            placement: 'right',
                            title: (
                                    <TourToGuide
                                        title={messages.user_tour_info_2}
                                        tourContentPlan="Brand"
                                    />),
                            content: messages.user_tour_info_2_content,
                            hideCloseButton: true,
                        },
                        {
                            target: '#user_tour_info_3',
                            title: (
                                <TourToGuide
                                    title={messages.user_tour_info_3}
                                    tourContentPlan="Brand"
                                />),
                            content: messages.user_tour_info_3_content,
                            hideCloseButton: true,
                            spotlightClicks: true,
                        },
                        {
                            target: '#user_tour_info_4',
                            placement: 'left',
                            title: (
                                <TourToGuide
                                    title={messages.user_tour_info_4}
                                    tourContentPlan="Brand"
                                />),
                            content: messages.user_tour_info_4_content,
                            hideCloseButton: true,
                        },
                        {
                            target: '#user_tour_info_5',
                            title: (
                                <TourToGuide
                                    title={messages.user_tour_info_5}
                                    tourContentPlan="Brand"
                                />),
                            content: messages.user_tour_info_5_content,
                            hideCloseButton: true,
                        },
                        {
                            target: '#user_tour_info_6',
                            placement: 'left',
                            title: (
                                <TourToGuide
                                    title={messages.user_tour_info_6}
                                    tourContentPlan="Brand"
                                />),
                            content: messages.user_tour_info_6_content,
                            hideCloseButton: true,
                        },
                        {
                            target: '#user_tour_info_7',
                            title: (
                                <TourToGuide
                                    title={messages.user_tour_info_7}
                                    tourContentPlan="Brand"
                                />),
                            content: messages.user_tour_info_7_content,
                            hideCloseButton: true,
                        },
                        {
                            target: '#user_tour_info_8',
                            title: (
                                <TourToGuide
                                    title={messages.user_tour_info_8}
                                    tourContentPlan="Agency"
                                />),
                            content: messages.user_tour_info_8_content,
                            hideCloseButton: true,
                        },
                        {
                            target: '#user_tour_info_9',
                            title: (
                                <TourToGuide
                                    title={messages.user_tour_info_9}
                                    tourContentPlan="Agency"
                                />),
                            content: messages.user_tour_info_9_content,
                            hideCloseButton: true,
                            spotlightClicks: true,
                        },
                        {
                            target: '#sidebar_prposalList',
                            title: (
                                <TourToGuide
                                    title={messages.user_tour_info_10}
                                    tourContentPlan="Agency"
                                />),
                            content: messages.user_tour_info_10_content,
                            hideCloseButton: true,
                            spotlightClicks: true,
                        },
                    ]}
                    styles={{
                        options: {
                        //   backgroundColor: '#e94242',
                        //   overlayColor: 'rgba(0, 0, 0, 0.4)',
                          primaryColor: '#e94242',
                          textColor: '#666',
                        //   width: 900,
                          zIndex: 30001,
                        },
                        tooltipTitle: {
                            color: '#666',
                        }
                      }}
                    
                    locale={{
                        back: messages.user_tour_previous, 
                        next: messages.user_tour_next, 
                        close: 'Close', 
                        last: messages.user_tour_finish, 
                        skip: messages.user_tour_finish }}
                    />
                {isLoading && <LoadingSpinner justifyContentCenter minHeight={'calc(100vh - 72px)'}/>}
                {!isLoading && <Container>
                    <MainNav infoId={infoId}></MainNav>
                    <Creator infoId={infoId}/>
                    <Rank />
                    <Recent />
                    <PastDay />
                    <PastMonth />
                    <Graph />
                    <PaymentBanner bannerPlan={"Brand"}/>
                </Container>}
            </Provider>
        );
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        payment: state.Payment,
        recent: state.RecentChannels,
        messages: state.Messages,
        tour: state.Tour,
    };
};
export default withRouter(connect(mapStateToProps)(withTourCheck(Info)));

const Container = styled.div`
    display: grid;
    overflow: scroll;
    grid-template-columns: 240px 420px 420px;    
    /* grid-template-rows: 60px 320px 120px 160px; */
    grid-template-rows: auto auto auto auto;
    grid-template-areas:
    "mainnav mainnav mainnav"
    "creator rank rank"    
    "creator recent recent"
    "creator pastDay pastMonth"
    "creator graph graph";
    grid-gap: 20px;
    justify-content: center;
    min-height: calc(100vh - 72px);
    background-color: #fafafa;
    border-left: 1px solid #e6e6e6;    
    padding-bottom:20px;
    @media (max-width: 900px){
        justify-content: initial;
    }
`



// WEBPACK FOOTER //
// ./src/Info.js